<template>
  <v-dialog v-model="internalShow" max-width="720px">
    <v-card class="kiosk-card">
      <v-toolbar flat color="white">
        <v-toolbar-title class="toolbar-title">{{ adminText('workflowsAll.kiosk_terminal_locations_8c64ecc', 'Kiosk terminal locations') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon color="#979797">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <p class="mb-6 description">
        {{ adminText('workflowsAll.we_re_actively_rolling_out_self_service_kiosk_bbc300f', 'We’re actively rolling out self-service kiosks in various locations. Here’s a list of the ones currently live and ready to use:') }}
      </p>

      <v-card-text class="scrollable-card-text">
        <div
          v-for="(group, i) in normalizedLocations"
          :key="i + 'group'"
          class="mb-6 list-item-container"
        >
          <div class="group-title">{{ workflowLabel(group.name) }}</div>
          <div class="kiosk-list">
            <div v-for="(t, index) in group.terminals" :key="index" class="kiosk-list-item">
              <v-icon :color="t.isActive ? '#0277BD' : '#D9D9D9'" class="terminal-icon">
                {{ t.isActive ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
              </v-icon>
              <div :class="terminalTitleClass(t.isActive)">
                {{ workflowLabel(t.name) }}
              </div>
              <div class="terminal-subtitle">{{ workflowLabel(t.address) }}</div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="card-actions">
        <v-spacer />
        <main-button color="#0277BD" depressed :text="adminText('workflowsAll.ok_9ce3bd4', 'OK')" @click="close" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_KIOSKS } from '@/graphql/kiosk.graphql'
export default {
  mixins: [WorkflowDisplay],
  name: 'kiosk-terminals-info-modal',
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      internalShow: this.show,
      kiosks: [],
      kiosksLoading: false,
      kiosksError: null,
    }
  },
  computed: {
    normalizedLocations() {
      const byCity = {}
      for (const k of this.kiosks) {
        const city = k.city || 'Other'
        if (!byCity[city]) byCity[city] = []
        byCity[city].push({
          ...k,
          address: `${k.locationName}, ${k.address}, ${k.city}`,
        })
      }

      return Object.keys(byCity).map(city => ({ name: city, terminals: byCity[city] }))
    },
  },
  watch: {
    show(val) {
      this.internalShow = val
      if (val) {
        this.fetchKiosks()
      }
    },
    internalShow(val) {
      this.$emit('update:show', val)
    },
  },
  mounted() {
    if (this.internalShow) {
      this.fetchKiosks()
    }
  },
  methods: {
    terminalTitleClass(active) {
      return active ? 'terminal-title' : 'terminal-title-inactive'
    },
    close() {
      this.internalShow = false
    },
    async fetchKiosks() {
      this.kiosksLoading = true
      this.kiosksError = null
      try {
        const { data } = await this.$apollo.query({
          query: GET_KIOSKS,
          fetchPolicy: 'network-only',
        })
        this.kiosks = data.getKiosks || []
      } catch (e) {
        this.kiosksError = e
      } finally {
        this.kiosksLoading = false
      }
    },
  },
}
</script>

<style scoped>
.kiosk-card {
  max-height: 524px;
  display: flex;
  flex-direction: column;
}
.description {
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  padding: 0 24px;
}
.group-title {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  margin-bottom: 8px;
  margin-top: 8px;
}
.list-item-container {
  padding: 0 12px;
}
.kiosk-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kiosk-list-item {
  display: flex;
  gap: 8px;
}
.terminal-icon {
  margin-bottom: 4px;
}
.terminal-title {
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}
.terminal-title-inactive {
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}
.toolbar-title {
  color: #0277bd;
  font-family: Raleway;
  font-size: 20px;
  font-weight: 600;
  line-height: 120%;
}
.terminal-subtitle {
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
.card-actions {
  padding: 0 24px 24px 0;
}
.scrollable-card-text {
  max-height: 400px; /* prilagodi po želji */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* glatki scroll na mobilnim uređajima */
}
</style>
